import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const verboseBadgeDefinition: BoggleBadgeDefinition = {
  category: 'mastery',
  description: 'Play 10 words of length 5+ in a row',
  iconId: 'verbose',
  id: 'verbose',
  level: 'rare',
  lockedReveal: 'reveal',
  name: 'Verbose',
  points: getBoggleBadgePointsForLevel('rare'),
}
